import Cookies from "js-cookie";

const DJANGO_SESSION_COOKIE_NAME = "sessionid";
const DJANGO_CSRF_COOKIE_NAME = "csrftoken";

const ACCESS_TOKEN_COOKIE_NAME = "wayflyer-accessToken-user";

export function setAuthCookies({ accessToken }: { accessToken: string }): void {
  Cookies.set(ACCESS_TOKEN_COOKIE_NAME, accessToken, {
    expires: 1, // (days)
    sameSite: "lax",
    secure: true,
  });
}

export function clearAuthCookies(): void {
  for (const cookieName of [ACCESS_TOKEN_COOKIE_NAME, DJANGO_SESSION_COOKIE_NAME, DJANGO_CSRF_COOKIE_NAME]) {
    Cookies.remove(cookieName, {
      sameSite: "lax",
      secure: true,
    });
  }
}
